(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["swatches"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function(e) {
    const swatch = e.target.closest('.custom-swatch');
    if (!swatch) return;

    e.preventDefault();
    e.stopPropagation();

    const container = swatch.closest('.custom-swatches');
    if (!container) return;

    const fullImage = swatch.dataset.fullImage;
    if (!fullImage) return;

    container.querySelectorAll('.custom-swatch').forEach((s) => s.classList.remove('active'));
    swatch.classList.add('active');

    const card = swatch.closest('product-card');
    if (!card) return;

    const mainImage =
      card.querySelector('.card__media img') ||
      card.querySelector('.media img') ||
      card.querySelector('img');

    if (!mainImage) return;

    mainImage.src = fullImage;
    mainImage.removeAttribute('srcset');
  });
  } catch(e) { console.error(e); }
})();

})();
